module.exports = __webpack_public_path__ + "img/31.42eed6fd.jpg";